import React from 'react';
import Modal from '@omilia/modal';

import ModalButtons from 'components/ModalButtons';
// @ts-ignore
import messages from 'constants/messages';
import { SContainer } from '../styled';

type Props = {
  error: string;
  onClose: () => void;
};

const FailureModal = ({ error, onClose }: Props) => (
  <Modal
    open
    shouldCloseOnEscPress
    glyph="notification-warning"
    title={messages.VERSION_CONTROL.MERGE_MODAL.MERGE_REQUEST_FAILED}
    variant="danger"
  >
    <SContainer>
      {error}
      <ModalButtons
        primary={{ text: 'Close', onClick: onClose, type: 'button' }}
      />
    </SContainer>
  </Modal>
);

export default FailureModal;
